import { render } from "./EventCard.vue?vue&type=template&id=b389dc54&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=b389dc54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b389dc54"

export default script